import React, { useCallback, useEffect, useState } from 'react';
import { Clapperboard } from 'lucide-react';
import api from '@/lib/api';
import { FormulaireVideo } from '@/components/videos/FormulaireVideo';
import { CarteVideo } from '@/components/videos/CarteVideo';
import { ReponsesCommentaires } from '@/components/videos/ReponsesCommentaires';

const EN_COURS = ['en_attente', 'script', 'tournage'];

export default function VideosViralesPage() {
  const [config, setConfig] = useState(null);
  const [videos, setVideos] = useState([]);
  const charger = useCallback(() => api.get('/videos-virales').then((r) => setVideos(r.data.videos)).catch(() => {}), []);
  useEffect(() => { api.get('/videos-virales/config').then((r) => setConfig(r.data)).catch(() => {}); charger(); }, [charger]);
  const enCours = videos.some((v) => EN_COURS.includes(v.statut));
  useEffect(() => {
    if (!enCours) return undefined;
    const t = setInterval(charger, 8000);
    return () => clearInterval(t);
  }, [enCours, charger]);
  return (
    <div className="max-w-7xl mx-auto p-4 md:p-8 space-y-8" data-testid="videos-virales-page">
      <div className="flex items-start gap-3">
        <div className="w-11 h-11 rounded-xl bg-primary/10 flex items-center justify-center"><Clapperboard className="w-6 h-6 text-primary" /></div>
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Vidéos virales</h1>
          <p className="text-sm text-stone-600">Reels, Shorts et vidéos Facebook tournés par l'agent commercial. Rien n'est publié sans votre OK.</p>
        </div>
      </div>
      <div className="grid lg:grid-cols-[1fr_380px] gap-6">
        <FormulaireVideo config={config} onCree={charger} />
        <ReponsesCommentaires />
      </div>
      <section className="space-y-3">
        <h2 className="text-lg font-semibold">Mes vidéos <span className="text-stone-400 font-normal">({videos.length})</span></h2>
        {!videos.length && <p className="text-sm text-stone-500" data-testid="vv-vide">Aucune vidéo pour l'instant : choisissez une idée et lancez le tournage.</p>}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-testid="vv-galerie">
          {videos.map((v) => <CarteVideo key={v.id} v={v} connexions={config?.connexions} onMaj={charger} />)}
        </div>
      </section>
    </div>
  );
}
